function scrollToTarget() {
    var targetDiv = document.getElementById('xcruise-info');
    if (targetDiv) {
        targetDiv.scrollIntoView({ behavior: 'auto' }); // Disable smooth scrolling temporarily
        setTimeout(function () {
            targetDiv.scrollIntoView({ behavior: 'smooth' }); // Enable smooth scrolling after a short delay
        }, 1);
    }
}

  // Get a reference to the toggle button element
  const toggleSafetyButton = document.getElementById('toggleSafetySpeaker');

  // Get a reference to the safety speaker element
  const safetySpeaker = document.querySelector('.safty-speaker-image');

  // Add a click event listener to the toggle button
  toggleSafetyButton.addEventListener('click', function () {
    // Toggle the display property of the safetySpeaker element
    safetySpeaker.style.display = safetySpeaker.style.display === 'none' ? 'block' : 'none';
  });



